export default "__VITE_ASSET__BkR04h$x__"